<template>
<div class="chapter">
<div class="inner_page">
<div class="centerImage1">
<img alt="image" class="imagefp" src="Images/logo1.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743299084_titlePage_01.vue?cd59be3c